import { render, staticRenderFns } from "./sentableCars.vue?vue&type=template&id=61a42e92&scoped=true"
import script from "./sentableCars.vue?vue&type=script&lang=js"
export * from "./sentableCars.vue?vue&type=script&lang=js"
import style0 from "./sentableCars.vue?vue&type=style&index=0&id=61a42e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a42e92",
  null
  
)

export default component.exports